// 묶음상품 그룹 섹션 URL (2026-10-15 KST 추가)
export const bundleShippingGroupsPath = "/bundle-shipping-groups";
